exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-back[data-v-71c1454b]{width:70px}", ""]);

// exports
